<template>
  <div v-if="isRouterAlive">
    <Slider
      :banner="$t('sliderimg')"
    >
      <div class="row align-items-center">
        <div class="col fontsiyuanmedium">
          <div class="slider-news2-title fontsiyuanmedium">
            {{ $t("slidertitle") }}
          </div>
          <div class="slider-news2-subtitle fontsiyuanregular">
            {{ $t("slidersubtitle") }}
          </div>
        </div>
      </div>
    </Slider>
    <div>
      <!-- 标题栏 -->
      <div class="news-title-wide news-title-group sticky2">
        <b-container>
          <div class="row justify-content-center">
            <div
              :class="`col-md-2 col-sm-3 news-title ${
                active == 0 ? 'active' : ''
              }`"
              @click="change(0)"
            >
              <span> {{ $t("title2t1") }}</span>
            </div>
            <div
              :class="`col-md-2 col-sm-3 news-title ${
                active == 1 ? 'active' : ''
              }`"
              @click="change(1)"
            >
              <span> {{ $t("title2t2") }}</span>
            </div>
            <div
              :class="`col-md-2 col-sm-3 news-title ${
                active == 2 ? 'active' : ''
              }`"
              @click="change(2)"
            >
              <span> {{ $t("title2t3") }}</span>
            </div>
            <div
              :class="`col-md-2 col-sm-3 news-title ${
                active == 3 ? 'active' : ''
              }`"
              @click="change(3)"
            >
              <span> {{ $t("title2t4") }}</span>
            </div>
          </div>
        </b-container>
      </div>
      <div class="news-title-thin">
        <b-container>
          <div class="news-title-header" @click="visible1 = !visible1">
            <span class="news-title-title">{{ $t("title2list")[0] }}</span>
            <span class="news-title-button"
              ><b-img v-if="!visible1" :src="colarrowdown"></b-img
              ><b-img v-if="visible1" :src="colarrowup"></b-img
            ></span>
          </div>
          <b-collapse
            v-model="visible1"
            class="thin-item-body"
            style="z-index: 1703"
          >
            <div class="news-title-header" @click="change(1)">
              <span class="news-title-title">{{ $t("title2list")[1] }}</span>
            </div>
            <div class="news-title-header" @click="change(2)">
              <span class="news-title-title">{{ $t("title2list")[2] }}</span>
            </div>
            <div class="news-title-header" @click="change(3)">
              <span class="news-title-title">{{ $t("title2list")[3] }}</span>
            </div>
          </b-collapse>
        </b-container>
      </div>

      <div class="news-list">
        <b-container>
          <div class="row">
            <div
              class="col-12 col-sm-6 col-md-4"
              v-for="(item, index) in $t(newslistname)"
              v-bind:key="index"
            >
              <!-- {{JSON.stringify(productlist[index][index2])}} -->
              <div class="news-item" @click="viewnews(index, item.newskey,item)">
                <b-img
                  style="padding: 20px"
                  :src="item.newsimg"
                  fluid
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
                <div class="news-body">
                  <div class="product-item-body-head row">
                    <div class="product-item-date">
                      VR:&ensp;{{ item.newsdate }}
                    </div>
                  </div>
                  <div class="news-item-title">
                    {{ parseInt(item.newskey) == 1 ? "*" : "" }}
                    {{ item.newstitle }}
                  </div>
                  <div class="news-item-info">{{ item.newsinfo }}</div>
                </div>
              </div>
            </div>
          </div>
          <b-pagination
            class="news-pagination"
            align="center"
            v-model="page"
            :total-rows="rows"
            :per-page="limit"
            first-number
            last-number
          >
            <template #prev-text><span class="pagestyle">&lt;</span></template>
            <template #next-text><span class="pagestyle">&gt;</span></template>
          </b-pagination>
        </b-container>
      </div>
    </div>
    <div></div>
    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
import Sticky from "sticky-js";
export default {
  components: {
    Slider,
    Footer,
  },
  data() {
    return {
      isRouterAlive: true,

      active: 0,
      newslist: [],

      limit: 12,
      page: 1,
      type: 0,

      rows: 0,

      visible1: false,

      newslistname:''
    };
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getNews() {
      const _this = this;
      this.$store.dispatch("getNews").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
      });
    },
    getVrPage() {
      const _this = this;
      this.isRouterAlive = false;
      this.$store
        .dispatch("getVrPage", {
          limit: _this.limit,
          page: _this.page,
          type: _this.active,
        })
        .then((data) => {
          _this.rows = data.total;
          let zh = [];
          let en = [];
          data.list.forEach((element) => {
            zh.push({
              newsid: element.id,
              newsimg: element.img,
              newstitle: element.title,
              newsdate: element.effect_at,
              newslink: element.link,
              newsinfo: element.desc,
              newskey: element.key,
            });
            en.push({
              newsid: element.id,
              newsimg: element.img,
              newstitle: element.title_en,
              newsdate: element.effect_at,
              newslink: element.link,
              newsinfo: element.desc_en,
              newskey: element.key,
            });
          });

          _this.newslistname = `newslist${new Date().getTime()}`;
          let enObj = {};
          let zhObj = {};
          enObj[_this.newslistname] = en;
          zhObj[_this.newslistname] = zh;
          _this.$i18n.mergeLocaleMessage("en", enObj);
          _this.$i18n.mergeLocaleMessage("zh", zhObj);
          

          let lang = _this.$i18n.locale;
          _this.$i18n.locale = lang;
          _this.reload();
          _this.isRouterAlive = true;


          const sticky2 = new Sticky(".sticky2");
          sticky2.update();
        });
    },
    change(index) {
      this.$router.push({
        path: `/news${2 + parseInt(index)}`,
      });
    },
    demo() {
      for (let i = 0; i < 12; i++) {
        this.newslist.push({
          img: "https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/newsvr.png",
          date: "2021-03-31",
          title: "天鑫软管车间VR",
          info: "专业燃气仪表及不锈钢波纹软管及管件、阀门、燃气用具连接用金属包覆软管、波纹金属软管...",
        });
      }
    },
    viewnews(index, key,item) {
      const _this = this;
      if (parseInt(key) == 1 && localStorage.getItem("pwd") != "access") {
        _this.$bvToast.toast(
          `该文章需要密码才可以打开，3秒后将跳转到密码登录页！`,
          {
            title: "警告",
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
            variant: "danger",
          }
        );

        _this.$store.state.loginpath = item.newslink
        _this.$store.state.loginmode = 'out'
        setTimeout(function () {
          _this.$router.push("/login");
        }, 3000);
      }else{
        window.open(item.newslink,'_blank')
      }
    },
  },
  mounted() {
  },
  created() {
    this.$i18n.locale = localStorage.getItem("lang") || "zh";
    this.active = 0;
    this.getNews();
    this.getVrPage();
  },
};
</script>
<style>


.slider-news2-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-news2-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.news-title-group {
  margin-top:10px;
  z-index: 1703;
  border-bottom: 0.5px #bdbdbd88 solid;
  background-color: #fff;
  height:75px;
}
.news-title {
  padding: 25px 0;
  cursor: pointer;
}
.news-title span {
  padding: 28px 0;
}
.news-title span:hover {
  color: #c00f31;
  font-weight: 800;
  border-bottom: 3px solid #c00f31;
}
.news-title.active span {
  border-bottom: 3px solid #c00f31;
}
.news-title.active {
  color: #c00f31;
  font-weight: 800;
}
.news-list {
  padding-bottom: 100px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 20px;
  cursor: pointer;
  background-color: #ededed;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 20px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  color: #8a8a8a;
}
@media only screen and (max-width: 500px) {
  .slider-news2-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-news2-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}

.news-title-thin {
  display: none;
}
@media only screen and (max-width: 500px) {
  .news-title-wide {
    display: none;
  }
  .news-title-thin {
    display: block;
  }
  .news-title-button img {
    width: 15px;
    position: absolute;
    right: 30px;
  }
  .news-title-header {
    font-size: 15px;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px #bdbdbd44 solid;
  }
}
</style>
